import axios from './api/axios';
import { useRef, useState, useEffect, useContext } from 'react';
const LOGOUT_URL = '/logout';


const Logout = () => {
  const [errMsg, setErrMsg] = useState('');
  const errRef = useRef();

  const afmelden = async () => {


    try {
      sessionStorage.removeItem("user")
      sessionStorage.removeItem("userid")
      sessionStorage.removeItem("accessToken")

      sessionStorage.removeItem("projectId");
      sessionStorage.removeItem("eindklant");
      sessionStorage.removeItem("eindklantId");
      sessionStorage.removeItem("bestandsnaam");
      sessionStorage.removeItem("woningTree");
      sessionStorage.removeItem("loadedWoning");
      sessionStorage.removeItem("offerteModules");

      sessionStorage.removeItem("DbCustommers");
      sessionStorage.removeItem("DbExtendedModuleTypes");
      sessionStorage.removeItem("DbModules");
      sessionStorage.removeItem("modulesInputs");
      sessionStorage.removeItem("modulesOutputs");
      sessionStorage.removeItem("nodeId");
      sessionStorage.removeItem("role");
      sessionStorage.removeItem("status");
      sessionStorage.removeItem("uitvoering");
      sessionStorage.removeItem("uitvoeringText");
      sessionStorage.removeItem("userid");



      await axios.post(LOGOUT_URL)
    } catch (err) {
      console.log(err)
      /*
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      errRef.current.focus();
      */
    }
  };

  afmelden();


  return (
    <div>
      <h1>Afgemeld</h1>
    </div>
  );
};

export default Logout;
